var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.532,
    height: 25.398,
    viewBox: "0 0 22.532 25.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security-guard-svgrepo-com",
    transform: "translate(-27.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_13_",
    transform: "translate(27.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M45.7,312.015a15.43,15.43,0,0,1-2.506-1.168.79.79,0,0,0-.97.095h0a5.338,5.338,0,0,1-3.188,1.166h-.405a5.337,5.337,0,0,1-3.188-1.166h0a.79.79,0,0,0-.97-.095,15.426,15.426,0,0,1-2.506,1.168c-3.034,1.094-4.4,2.21-4.4,2.97v4.984H50.1v-4.984C50.1,314.225,48.735,313.109,45.7,312.015Z",
    transform: "translate(-27.567 -294.572)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M135.5,7.971a21.114,21.114,0,0,0,.315-2.141c.092-1.223,1.631-2.968.954-2.968A8.42,8.42,0,0,1,133.5,2.1c-.989-.416-1.851-2.1-2.794-2.1h-.048c-.943,0-1.8,1.687-2.794,2.1a8.419,8.419,0,0,1-3.272.759c-.676,0,.862,1.745.955,2.968a21.105,21.105,0,0,0,.315,2.141s-.445.2-.445,1.021c.156,2.051.972,1.167,1.14,2.065A4.464,4.464,0,0,0,128.977,14a4.495,4.495,0,0,0,3.4,0,4.463,4.463,0,0,0,2.426-2.947c.168-.9.984-.015,1.14-2.065C135.943,8.174,135.5,7.971,135.5,7.971ZM131.863,3.41a1.185,1.185,0,0,1-2.37,0v-.8s0-.007,0-.011,0,0,0,0a.354.354,0,0,1,.335-.353l.007,0h1.689a.336.336,0,0,1,.334.3s0,.006,0,.009,0,.011,0,.017,0,.012,0,.019C131.863,2.8,131.863,3.15,131.863,3.41Z",
    transform: "translate(-119.382)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantSecurity);
export default __webpack_public_path__ + "static/media/tenant_security.65fb4a2cf549e3f4fb8a2c682e31e26a.svg";
export { ForwardRef as ReactComponent };